const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{eID} .text-edit #{titleTag}',
};
export default {
  defaultClass: 'gf_gs-text-heading-2',
  settingGroups: {
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'line-height': {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      'letter-spacing': {
        ...defaultSelector,
        inherit: 'text.letterSpacing',
        cssAttr: 'letter-spacing',
        listUnit: 'px',
      },
      // "text-color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
  },
};

export const HEADING_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    titleTag: 'h1,h2,h3,h4,h5,h6',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading',
  },
];
